import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';

@Injectable({ providedIn: 'root' })
export class ResumeOnboardingService {
  private postponedForCurrentVisit = false;

  constructor(private sharedService: SharedService) { }

  shouldShow(user: any): boolean {
    if (!this.sharedService.isBrowser || !this.userKey(user) || user?.Operator?.Disabled === false) return false;
    const seeker = user?.Seeker;
    const hasCompleteResume = Number(seeker?.Completeness) > 50;

    return seeker != null
      && (!hasCompleteResume || seeker.ExpiredPromote !== false)
      && !this.postponedForCurrentVisit;
  }

  postpone(): void {
    this.postponedForCurrentVisit = true;
  }

  resetPostponement(): void {
    this.postponedForCurrentVisit = false;
  }

  private userKey(user: any): string {
    return user?.Id || user?.Code || user?.Mobile || '';
  }
}
